// NPM
import React, { Component } from 'react';

import RecommendationFavoriteButton from './RecommendationFavoriteButton';
import RecommendationHideButton from './RecommendationHideButton';

class RecommendationActions extends Component {
  render() {
    const { recommendation, showHideButton, showFavoriteButton } = this.props;
    return (
      <div className="RecommendationActions">
        {showFavoriteButton && (
          <RecommendationFavoriteButton recommendation={recommendation} />
        )}
        {showHideButton && (
          <RecommendationHideButton recommendation={recommendation} />
        )}
      </div>
    );
  }
}

export default RecommendationActions;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationActions.js